
import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Renderer2,
  DOCUMENT
} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appToolDropdown]',
})
export class ToolDropdownDirective {
  constructor(
    private readonly elemRef: ElementRef,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}
  @HostListener('click', ['$event.target']) toggleClass(target: any) {
    if (this.elemRef.nativeElement.className.includes('is-active')) {
      this.renderer.removeClass(this.elemRef.nativeElement, 'is-active');
    } else {
      this.renderer.addClass(this.elemRef.nativeElement, 'is-active');
      this.renderer.addClass(
        this.elemRef.nativeElement.querySelector(
          '.dropdown-menu',
        ) as HTMLElement,
        'open',
      );
    }
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;

    // Check if the click was outside the host element
    if (targetElement && !this.elemRef.nativeElement.contains(targetElement)) {
      this.renderer.removeClass(this.elemRef.nativeElement, 'is-active');
      this.renderer.removeClass(
        this.elemRef.nativeElement.querySelector(
          '.dropdown-menu',
        ) as HTMLElement,
        'open',
      );
    }
  }
}
